<template>
    <div class="sa-content">
        <div class="sa-card-large">
            <div class="sa-mob-header">
                <h5 class="sa-card-tit">Family Members</h5>
                <button class="sa-btn-back" @click="$router.go(-1)">
                    <i class="icon-arrow-left"></i>
                </button>
            </div>
            <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader sa-loader-top" v-if="loader" />
            <div class="sa-mob-cont" v-else>
                <div class="sa-row sa-pd">
                    <div class="ssa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg4 ">
                        <family-member-filters :slctService="status" @select-filter="selectFilter"/>
                    </div>
                    <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg8">
                        <div v-for="familyMember in familyMembers" :key="familyMember.id">
                            <families-members-details :familyMember="familyMember" class="sa-cursor" />
                        </div>
                        <button class="sa-btn sa-btn-large sa-btn-primary sa-btn-block"  v-if="!loader"
                            @click="$router.push('/appointments')">All Appointments</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { family_url } from "../../../config/endpoints";
import FamiliesMembersDetails from '../../components/familydoctors/FamiliesMembersDetails.vue'
import FamilyMemberFilters from '../../components/familydoctors/FamilyMemberFilters.vue'

export default {
    components: {
        FamiliesMembersDetails,
        FamilyMemberFilters,
    },
    data() {
        return {
            familyMembers: null,
            status: 'all',
            loader: false
        }
    },
    mounted() {
        this.familyMembersData()
    },
    methods: {
        selectFilter(val){
            this.status = val
            this.familyMembersData()
        },
        familyMembersData() {
            let _self = this
            _self.loader = true
            const body = {
                suid: this.$route.query.suid,
                active: this.status
            }
            _self.$store.dispatch("httpPost", { uri: `${family_url}/patient`, body })
                .then((response) => {
                    _self.loader = false
                    if (response && response.status == 1000) {
                        _self.familyMembers = response.data
                    } else {
                        _self.loader = false
                        _self.$store.dispatch("SET_ALERTMESSAGE", {
                            msg: "Something went wrong",
                            class: "sa-a-danger"
                        });
                    }
                })
        }
    },
}
</script>
